import React from "react";
import { DisplayAlarmList } from "../config";
import { SupportedLanguage } from "../App";

export interface SystemInfo {
  systemId: string;
  systemName: string;
  companyName: string;
}

export interface FrontEndContextInterface {
  handleAuthentication: (userSession: any, error?: any) => void;
  setBearerToken: (token: string) => void;
  headersWithAuth: any;
  userName: string;
  setUserName: (userName: string) => void;
  isAdmin: boolean;
  isAuthenticating: boolean;
  isAuthenticated: boolean;
  doLogin: () => void;
  doLogout: () => void;
  systems: SystemInfo[];
  dataLoaded: boolean;
  alarmList: DisplayAlarmList[];//DM added February 5. Show alerts
  language: SupportedLanguage;
  setLanguage: (lang: SupportedLanguage) => void;
  t: (key: string) => string;
  wheelCount: number;
}

const FrontEndContext = React.createContext<FrontEndContextInterface>({
  handleAuthentication: (userSession: any, error?: any) => { },
  setBearerToken: () => { },
  headersWithAuth: {},
  userName: "",
  setUserName: () => { },
  isAdmin: false,
  isAuthenticating: false,
  isAuthenticated: false,
  doLogin: () => { },
  doLogout: () => { },
  systems: [],
  dataLoaded: false,
  alarmList: [],//DM added February 5. Show alerts
  language: 'en',//Changed from de.
  setLanguage: () => { },
  t: (key: string) => key,
  wheelCount: 0,
});

export default FrontEndContext;
